<template>
  <div>
    <div v-if="editable">
      <div class="w-full flex items-center gap-[16px] flex-wrap">
        <div v-if="croppedImage" class="flex items-center gap-[4px] setWrap">
          <div class="BodyS text-[#1F1D1F] break-all">
            {{ `ขนาดรูป : ${currentFileSizeMB} MB / 100 MB` }}
          </div>
          <div
            @click="removeImage"
            class="w-[32px] h-[32px] flex items-center justify-center cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M22.3236 11.325C22.7793 10.8693 22.7793 10.1306 22.3236 9.67498C21.868 9.21934 21.1293 9.21934 20.6737 9.67498L15.9987 14.3499L11.3238 9.67498C10.8681 9.21935 10.1294 9.21934 9.67377 9.67498C9.21814 10.1306 9.21814 10.8693 9.67377 11.325L14.3487 15.9999L9.67375 20.6749C9.21812 21.1305 9.21812 21.8692 9.67375 22.3249C10.1294 22.7805 10.8681 22.7805 11.3237 22.3249L15.9987 17.6499L20.6737 22.3249C21.1293 22.7805 21.868 22.7805 22.3237 22.3249C22.7793 21.8692 22.7793 21.1305 22.3237 20.6749L17.6487 15.9999L22.3236 11.325Z"
                fill="#EB5554"
              />
            </svg>
          </div>
        </div>
        <div v-else class="BodyS text-[#7c7379] setWrap">
          รูป .jpg .jpeg หรือ .png ขนาดไม่เกิน 100 mb เท่านั้น
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          class="hidden"
          @change="handleFileChange"
        />
        <div v-if="type == 1" class="btnMob items-center gap-[16px] flex-wrap">
          <ButtonComponent
            :label="'อัปโหลดรูป'"
            :bClass="'btn_shadow--1 w-full sm:w-fit min-w-[92px]'"
            :lClass="'textButtonS'"
            :dropdown="true"
            :dropdownClass="'uploadButtonDropdown1 !mt-[0px] !min-w-[197px] border-[#F3F2F2] shadow_B10-O8'"
            :dropdownList="[{ label: 'กล้องถ่ายรูป' }, { label: 'อัปโหลดรูป' }]"
            :dropdownListLClass="'PC_Body2-R'"
            @select="({ item }) => doAction(item)"
          />
        </div>
        <div v-if="type == 2" class="btnMob items-center gap-[16px] flex-wrap">
          <ButtonComponent
            :label="'อัปโหลดรูป'"
            :bClass="'btn_shadow--1 w-full sm:w-fit min-w-[92px]'"
            :lClass="'textButtonS'"
            :dropdown="true"
            :dropdownClass="'uploadButtonDropdown2 !mt-[0px] !min-w-[197px] border-[#F3F2F2] shadow_B10-O8'"
            :dropdownList="[{ label: 'กล้องถ่ายรูป' }, { label: 'อัปโหลดรูป' }]"
            :dropdownListLClass="'PC_Body2-R'"
            @select="({ item }) => doAction(item)"
          />
        </div>
        <div class="btnDes items-center gap-[16px] flex-wrap">
          <ButtonComponent
            :label="'อัปโหลดรูป'"
            :bClass="'btn_shadow--1 w-full sm:w-fit min-w-[92px]'"
            :lClass="'textButtonS'"
            @clicked="() => doAction({ label: 'อัปโหลดรูป' })"
          />
        </div>
      </div>

      <div
        v-if="showCropper"
        class="fixed inset-0 bg-black/60 z-50 flex justify-center w-full overflow-y-auto max-h-screen py-10"
      >
        <div
          class="w-[90%] h-[500px] flex flex-col justify-center gap-[22px] bg-white p-4 rounded-[6px] shadow-lg max-w-[550px]"
        >
          <Cropper
            ref="cropperRef"
            class="h-[396px] bg-black w-full"
            :src="imagePreview"
            :stencil-props="stencilProps"
          />
          <div class="flex items-center justify-center gap-[10px]">
            <ButtonComponent
              label="ยกเลิก"
              :bClass="'btn_shadow--cancel'"
              @clicked="showCropper = false"
            />
            <ButtonComponent
              label="ตกลง"
              :bClass="'btn_shadow--save'"
              @clicked="cropImage"
            />
          </div>
        </div>
      </div>

      <div
        v-if="showCamera"
        class="fixed inset-0 bg-black/60 z-50 flex justify-center w-full overflow-y-auto max-h-screen py-10"
      >
        <div
          class="w-[90%] h-[500px] flex flex-col justify-center gap-[22px] bg-white p-4 rounded-[6px] shadow-lg max-w-[550px]"
        >
          <video
            ref="videoRef"
            autoplay
            class="h-[396px] bg-black w-full"
          ></video>

          <div class="flex items-center justify-center gap-[10px]">
            <ButtonComponent
              label="ยกเลิก"
              :bClass="'btn_shadow--cancel'"
              @clicked="closeCamera"
            />
            <ButtonComponent
              label="ถ่ายรูป"
              :bClass="'btn_shadow--save'"
              @clicked="takePicture"
            />
          </div>
        </div>
      </div>
    </div>
    <ButtonComponent
      v-if="props.image && !editable"
      :label="'รูปประกอบ'"
      :bClass="'btn_shadow--cancel !px-[15px] !max-w-[90px] group hover:!bg-[#FBEFF8] hover:!border-[#9b237b]'"
      :lClass="'!text-[13px] group-hover:text-[#9B237B]'"
      @clicked="viewImage"
    />
    <!-- {{ props.image }} -->
    
    <ImageModal ref="ImageModalRef" />
    <StatusModal ref="StatusModalRefForUploadImage" />
  </div>
</template>

<script setup>
import { ref, watch, computed, nextTick } from "vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

// กำหนดขนาดสูงสุดของไฟล์เป็นไบต์ (100 MB)
const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;

const props = defineProps({
  type: {
    type: String,
    default: 1,
  },
  editable: {
    type: Boolean,
    default: true,
  },
  image: {
    type: [String, Number],
    default: "",
  },
  fileSizeMB: {
    type: [String, Number],
    default: "0.00",
  },
});
const emit = defineEmits(["update:image"]);

// refs
const cropperRef = ref(null);
const showCropper = ref(false);
const fileInput = ref(null);
const imagePreview = ref("");
const currentFileSizeMB = ref("0.00");
const croppedImage = ref(null);
const rawImage = ref(null);

// --- Refs สำหรับ Camera ---
const showCamera = ref(false);
const videoRef = ref(null);
let mediaStream = null;
const facingMode = ref("environment");

// modal
const ImageModalRef = ref(null);
const StatusModalRefForUploadImage = ref(null);

// stencil options
const stencilProps = ref({
  aspectRatio: 1,
  movable: true,
  scalable: true,
  resizable: true,
});

// sync external image and file size
watch(
  () => props.image,
  (val) => {
    if (typeof val === "string") {
      croppedImage.value = val;
    }
  },
  { immediate: true }
);

watch(
  () => props.fileSizeMB,
  (val) => {
    if (val !== undefined && val !== null) {
      currentFileSizeMB.value = String(val);
    }
  },
  { immediate: true }
);

const doAction = (data) => {
  if (data.label === "กล้องถ่ายรูป") {
    goCamera();
  } else if (data.label === "อัปโหลดรูป") {
    goUpload();
  }
};

const viewImage = () => {
  ImageModalRef.value.openModal(props.image);
};

const goCamera = async () => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    alert("เบราว์เซอร์ของคุณไม่รองรับการเข้าถึงกล้อง");
    return;
  }

  showCropper.value = false;

  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: facingMode.value,
      },
    });

    mediaStream = stream;
    showCamera.value = true;

    await nextTick();
    const video = videoRef.value;
    if (video) {
      video.srcObject = stream;
      video.play();
    }
  } catch (error) {
    console.error("Error accessing camera:", error);
    alert("ไม่สามารถเข้าถึงกล้องได้ กรุณาตรวจสอบการอนุญาตการใช้งานกล้อง");
  }
};

const closeCamera = () => {
  if (mediaStream) {
    mediaStream.getTracks().forEach((track) => track.stop());
    mediaStream = null;
  }
  showCamera.value = false;
};

const takePicture = () => {
  const video = videoRef.value;
  if (!video) return;

  const canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  canvas.toBlob(
    (blob) => {
      if (!blob) {
        console.warn("ไม่สามารถแปลงภาพเป็น Blob ได้");
        return;
      }

      // *** 💡 ตรวจสอบขนาดไฟล์ที่ถ่ายได้ (100 MB Max) ***
      if (blob.size > MAX_FILE_SIZE_BYTES) {
        closeCamera();
        StatusModalRefForUploadImage.value.openModal("error", {
          subHeader: `ไม่สามารถอัปโหลดรูปได้\n โปรดอัปโหลดรูปขนาดไม่เกิน 100 mb`,
        });
        return;
      }

      // ผ่านการตรวจสอบขนาดไฟล์
      const cameraFile = new File([blob], `camera_photo_${Date.now()}.jpeg`, {
        type: "image/jpeg",
      });

      closeCamera();

      rawImage.value = cameraFile;
      currentFileSizeMB.value = (cameraFile.size / 1048576).toFixed(2);

      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.value = e.target.result;
        showCropper.value = true;
      };
      reader.readAsDataURL(cameraFile);
    },
    "image/jpeg",
    1.0
  );
};

// trigger upload
const goUpload = () => {
  closeCamera();
  fileInput.value?.click();
};

// file input change
const handleFileChange = (e) => {
  const file = e.target.files?.[0];
  e.target.value = "";

  if (!file) return;

  const isImage =
    /\.(jpe?g|png)$/i.test(file.name) &&
    ["image/jpeg", "image/png"].includes(file.type);

  // *** 💡 ตรวจสอบขนาดไฟล์ที่อัปโหลด (100 MB Max) ***
  if (file.size > MAX_FILE_SIZE_BYTES) {
    StatusModalRefForUploadImage.value.openModal("error", {
      subHeader: `ไม่สามารถอัปโหลดรูปได้\n โปรดอัปโหลดรูปขนาดไม่เกิน 100 mb`,
    });
    return;
  }

  if (isImage) {
    currentFileSizeMB.value = (file.size / 1048576).toFixed(2);
    rawImage.value = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      imagePreview.value = e.target.result;
      showCropper.value = true;
    };
    reader.readAsDataURL(file);
  } else {
    StatusModalRefForUploadImage.value.openModal("error", {
      subHeader: `ไม่สามารถอัปโหลดรูปได้\n โปรดอัปโหลดรูปขนาดไม่เกิน 100 mb`,
    });
  }
};

// crop image
const cropImage = async () => {
  const result = cropperRef.value?.getResult?.();

  if (result?.canvas) {
    result.canvas.toBlob(
      (blob) => {
        console.log("blob", blob);
        if (blob) {
          // *** 💡 ตรวจสอบขนาดไฟล์หลัง Crop (100 MB Max) ***
          if (blob.size > MAX_FILE_SIZE_BYTES) {
            showCropper.value = false;

            StatusModalRefForUploadImage.value.openModal("error", {
              subHeader: `ไม่สามารถอัปโหลดรูปได้\n โปรดอัปโหลดรูปขนาดไม่เกิน 100 mb`,
            });
            return;
          }

          const croppedFile = new File([blob], rawImage.value.name, {
            type: blob.type,
          });

          const newSizeMB = (croppedFile.size / 1048576).toFixed(2);
          currentFileSizeMB.value = newSizeMB;

          croppedImage.value = URL.createObjectURL(croppedFile);
          emit("update:image", croppedFile);
          emit("update:fileSizeMB", currentFileSizeMB.value);
          showCropper.value = false;
        }
      },
      "image/jpeg",
      1.0
    );
  } else {
    console.warn("ไม่สามารถตัดรูปได้");
  }
};

// remove image
const removeImage = () => {
  croppedImage.value = null;
  currentFileSizeMB.value = "0.00";
  emit("update:image", null);
};
</script>

<style lang="scss" scoped>
.BodyS {
  // color: #7c7379;

  /* Body/s */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
.setWrap {
  width: 100%;
  @media screen and (min-width: 451px) {
    width: fit-content;
  }
}
.btnMob {
  display: flex;
  @media screen and (min-width: 1367px) {
    display: none;
  }
}
.btnDes {
  display: none;
  @media screen and (min-width: 1367px) {
    display: flex;
  }
}
</style>